import _objectSpread from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import { request } from '@/api/http';
import { listDict } from '@/api/sys/dict';
var AI_BASE_DICT_NAME = '基础服务';
var AI_ASSISTANT_PATH = '/api/v5/ai/leader-chat';
var AI_METRICS_PATH = '/api/v5/ai/metrics/list';
var aiAssistantBaseUrl = null;
var aiAssistantBaseUrlPromise = null;
function buildUrl(path) {
  return aiAssistantBaseUrl ? "".concat(aiAssistantBaseUrl).concat(path) : path;
}
function normalizeBaseUrl(url) {
  return (url || '').trim().replace(/\/$/, '');
}
function resolveAiAssistantBaseUrl() {
  return _resolveAiAssistantBaseUrl.apply(this, arguments);
}
function _resolveAiAssistantBaseUrl() {
  _resolveAiAssistantBaseUrl = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          if (!aiAssistantBaseUrl) {
            _context.n = 1;
            break;
          }
          return _context.a(2, aiAssistantBaseUrl);
        case 1:
          if (!aiAssistantBaseUrlPromise) {
            aiAssistantBaseUrlPromise = listDict({
              type: 0,
              page: 1,
              size: 10
            }).then(function (data) {
              var list = (data === null || data === void 0 ? void 0 : data.list) || [];
              var baseConfig = list.find(function (item) {
                return item.name === AI_BASE_DICT_NAME;
              });
              aiAssistantBaseUrl = normalizeBaseUrl((baseConfig === null || baseConfig === void 0 ? void 0 : baseConfig.value) || process.env.VUE_APP_AI_ASSISTANT_API || '');
              return aiAssistantBaseUrl;
            }).catch(function (error) {
              console.warn('获取 AI 服务地址字典失败，退回默认地址:', error);
              aiAssistantBaseUrl = normalizeBaseUrl(process.env.VUE_APP_AI_ASSISTANT_API || '');
              return aiAssistantBaseUrl;
            }).finally(function () {
              aiAssistantBaseUrlPromise = null;
            });
          }
          return _context.a(2, aiAssistantBaseUrlPromise);
      }
    }, _callee);
  }));
  return _resolveAiAssistantBaseUrl.apply(this, arguments);
}
export function leaderChat(_x, _x2) {
  return _leaderChat.apply(this, arguments);
}
function _leaderChat() {
  _leaderChat = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(data, options) {
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          _context2.n = 1;
          return resolveAiAssistantBaseUrl();
        case 1:
          return _context2.a(2, request(_objectSpread({
            url: buildUrl(AI_ASSISTANT_PATH),
            method: 'post',
            data: data
          }, options)));
      }
    }, _callee2);
  }));
  return _leaderChat.apply(this, arguments);
}
export function listAiMetrics(_x3) {
  return _listAiMetrics.apply(this, arguments);
}
function _listAiMetrics() {
  _listAiMetrics = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(options) {
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          _context3.n = 1;
          return resolveAiAssistantBaseUrl();
        case 1:
          return _context3.a(2, request(_objectSpread({
            url: buildUrl(AI_METRICS_PATH),
            method: 'get'
          }, options)));
      }
    }, _callee3);
  }));
  return _listAiMetrics.apply(this, arguments);
}
export function clearAiAssistantBaseUrlCache() {
  aiAssistantBaseUrl = null;
  aiAssistantBaseUrlPromise = null;
}
export default {
  leaderChat: leaderChat,
  listAiMetrics: listAiMetrics,
  clearAiAssistantBaseUrlCache: clearAiAssistantBaseUrlCache
};